import Vue from 'vue';

Vue.filter('cnpj', (value) => {
  if (!value || typeof value !== 'string') return value;
  return value.trim().replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
});
